<template>
<span v-if="length" :style="'color:'+color+';border-color:'+color" class="mr-2 p-1 font-bold border-2 border-solid border-round-md nonconformity_indicator animate_class cursor-pointer" @click="gotoActionPlan">
{{typename}} -  {{length}} 

</span>
</template>

<script>
export default {

  name: 'SupplierProjectFlowSummaryNonconformityNode',
  props:["type","nonconformities"],
  data () {
    return {
    	
    }
  },
  computed:{
  	length()
  	{
  		let nonconformities = this.nonconformities.filter(item=>item.nonconformitytype_id == this.type.id)
  		return nonconformities.length
  	},
  	color()
  	{
  		if(this.type.color && this.type.color!=="") 
  		{
  			return this.type.color
  		}
  		return "#352f8d"
  	},
  	typename()
  	{
  		return this.getTheTranslation(this.type,"translation")
  	}
  },
  methods:{
  	gotoActionPlan()
  	{
  		this.$emit("gotoActionPlan")
  	}
  }
}
</script>

<style lang="css" scoped>
	.nonconformity_indicator:hover{
		opacity: 0.7;
	}
</style>